// extracted by mini-css-extract-plugin
export default {"page-btn":"PageButtons_page-btn__yGLYg","fade-in":"PageButtons_fade-in__yW34Y","dropdown":"PageButtons_dropdown__FMqEj"};